import styles from './NothingFound.module.scss';

const NothingFound: React.FC<{
  label?: string;
}> = ({ label }) => {
  return <div className={styles.element}>{label || '- List is empty -'}</div>;
};

export default NothingFound;
